import { CircularProgress } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDInput from "components/Basics/MDInput";
import { getLabel } from "helpers/dictionary";
import { useEffect, useState } from "react";
import WhitelistItemV2 from "components/Custom/LittleForm/Inputs/Whitelist/WhitelistItemV2";
import lod_ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentProfile } from "redux-react/reducers/profileReducer";
import formActions from "redux-react/actions/formAction";

const InputString = ({
	filter,
	page,
	language,
	storage,
	updateStoreFilter,
	updateStoreFilterDebounce
}) => {
	const dispatch = useDispatch();
	const assistantID = useSelector(state => selectCurrentProfile(state).assistantID);

	const [listOfApis, setListOfApis] = useState([]);
	const [loadingApis, setLoadingApis] = useState(true);

	const [currentValue, setCurrentValue] = useState(storage);

	useEffect(() => {
		setCurrentValue(storage);
	}, [storage]);

	const hasWhitelistDynamic = !lod_.isEmpty(filter?.whitelistDynamic);

	/**
	 * Load list of APIs from backend — only needed for WhitelistItemV2 mode
	 */
	useEffect(() => {
		if (!hasWhitelistDynamic) {
			setLoadingApis(false);
			return;
		}

		if (listOfApis && listOfApis.length > 0) {
			return;
		}

		if (!assistantID) {
			return;
		}

		setLoadingApis(true);
		dispatch(
			formActions.getListApis(assistantID, res => {
				const apisList = res?.apisList || [];
				setListOfApis(apisList);
				setLoadingApis(false);
			})
		);
	}, [filter]);

	if (loadingApis) {
		return (
			<MDBox key={filter.attribute} mr={1} display="flex" alignItems="center">
				<CircularProgress size={20} />
			</MDBox>
		);
	}

	if (!hasWhitelistDynamic) {
		return (
			<MDBox key={filter.attribute} sx={{ width: "100%" }}>
				<MDInput
					size="small"
					label={getLabel(filter.label, language)}
					value={currentValue ?? ""}
					onChange={e => {
						const val = e.target.value;
						setCurrentValue(val);
						updateStoreFilterDebounce(val, filter, page);
					}}
					fullWidth
				/>
			</MDBox>
		);
	}

	return (
		<MDBox key={filter.attribute} sx={{ width: "100%" }}>
			<WhitelistItemV2
				size="small"
				label={getLabel(filter.label, language)}
				value={currentValue}
				onChange={newValue => {
					setCurrentValue(newValue);
					updateStoreFilter(newValue, filter, page);
				}}
				item={{
					whitelistDynamic: filter.whitelistDynamic
				}}
				listOfApis={listOfApis}
				InputProps={{}}
				isArray
				displaySource={false}
				draggable={false}
				displaySelection="number"
			/>
		</MDBox>
	);
};

export default InputString;
